// Valores comuns de mercado (setembro/2026) para o lojista partir de algum
// lugar — NUNCA verdade: cada contrato é um. A tela sempre diz "confira no seu
// contrato". Fontes na ficha (DOC.md).

const sem = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

const TIPOS = [
  { tipo: "ifood", teste: (n) => n.includes("ifood"), rotulo: "iFood",
    sugestoes: [{ nome: "Básico: 12% + 3,2% do pagamento online", taxa: 15.2, prazo: 30 }, { nome: "Entrega: 23% + 3,2% do pagamento online", taxa: 26.2, prazo: 30 }] },
  { tipo: "online_pix", teste: (n) => n.includes("pix") && n.includes("online"), rotulo: "PIX Online",
    sugestoes: [{ nome: "Mercado Pago", taxa: 0.99, prazo: 0 }] },
  { tipo: "online_cartao", teste: (n) => n.includes("online"), rotulo: "Cartão Online",
    sugestoes: [{ nome: "Mercado Pago, na hora", taxa: 4.98, prazo: 0 }, { nome: "Mercado Pago, 14 dias", taxa: 3.98, prazo: 14 }] },
  { tipo: "dinheiro", teste: (n) => n.includes("dinheiro"), rotulo: "Dinheiro",
    sugestoes: [{ nome: "Sem taxa", taxa: 0, prazo: 0 }] },
  { tipo: "pix", teste: (n) => n.includes("pix"), rotulo: "PIX",
    sugestoes: [{ nome: "PIX direto na conta", taxa: 0, prazo: 0 }, { nome: "PIX na maquininha", taxa: 0.99, prazo: 0 }] },
  { tipo: "voucher", teste: (n) => /vale|voucher|alelo|ticket|sodexo|pluxee|vr\b|refei|alimenta/.test(n), rotulo: "Vale-refeição",
    sugestoes: [{ nome: "Teto do PAT (Decreto 12.712/2025)", taxa: 3.6, prazo: 15 }] },
  { tipo: "debito", teste: (n) => n.includes("debito"), rotulo: "Débito",
    sugestoes: [{ nome: "Maquininha comum", taxa: 1.59, prazo: 1 }] },
  { tipo: "credito", teste: (n) => n.includes("credito"), rotulo: "Crédito",
    sugestoes: [{ nome: "Receber em 30 dias", taxa: 3.19, prazo: 30 }, { nome: "Receber no dia seguinte", taxa: 4.49, prazo: 1 }] },
  { tipo: "cartao", teste: (n) => n.includes("cartao") || n === "c", rotulo: "Cartão (débito e crédito juntos)",
    sugestoes: [{ nome: "Média débito + crédito", taxa: 2.5, prazo: 15 }, { nome: "Tudo no dia seguinte", taxa: 3.5, prazo: 1 }] },
];

/** Descobre o tipo pela chave/nome (a forma não guarda tipo) para sugerir valores. */
export function tipoDaForma(nome, chave) {
  const n = `${sem(nome)} ${sem(chave)}`.trim();
  return TIPOS.find((t) => t.teste(n)) || null;
}
